import { render, staticRenderFns } from "./OwnersForm.vue?vue&type=template&id=114c930a&"
import script from "./OwnersForm.vue?vue&type=script&lang=js&"
export * from "./OwnersForm.vue?vue&type=script&lang=js&"
import style0 from "./OwnersForm.vue?vue&type=style&index=0&id=114c930a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports